// Защищённый маршрут с проверкой ролей: редиректит неавторизованных на /login, а пользователей без нужной роли — на /dashboard.

import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

export default function ProtectedRoute({ roles, children }) {
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);
  const fetchMe = useAuthStore((s) => s.fetchMe);

  useEffect(() => {
    if (token && !user) fetchMe();
  }, [token]);

  if (!token) return <Navigate to="/login" replace />;
  if (roles) {
    if (!user) return null;
    if (!user.roles?.some((r) => roles.includes(r))) return <Navigate to="/dashboard" replace />;
  }
  return children;
}
